import {
  Box,
  Grid,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Alert,
  DialogActions,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import React, { useState, useEffect } from 'react';
import { formatQueryError } from 'renderer/shared/formatters/formatters';
import { useDeleteResellerCodeMutation } from '../services/resellerCodes.endpoints';
import ResellerCodeForm from './ResellerCodeForm';
import ResellerCodesList from './ResellerCodesList';

const ResellerCodesPage: React.FC = () => {
  const [
    deleteResellerCode,
    {
      isLoading: deleteIsLoading,
      error: deleteError,
      isSuccess: deleteSuccess,
    },
  ] = useDeleteResellerCodeMutation();

  const [isAddDialogOpen, setAddDialogOpen] = useState(false);
  const [isEditDialogOpen, setEditDialogOpen] = useState(false);
  const [isDeleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedResellerCode, setSelectedResellerCode] = useState<any>(null);

  useEffect(() => {
    if (deleteSuccess) {
      setDeleteDialogOpen(false);
    }
  }, [deleteSuccess]);

  const handleAddClick = () => {
    setAddDialogOpen(true);
  };

  const handleEditClick = (resellerCode: any) => {
    setSelectedResellerCode(resellerCode);
    setEditDialogOpen(true);
  };

  const handleDeleteClick = (resellerCode: any) => {
    setSelectedResellerCode(resellerCode);
    setDeleteDialogOpen(true);
  };

  return (
    <Box sx={{ p: 2 }}>
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 2 }}
      >
        <Grid item>
          <Typography variant="h4">Reseller codes</Typography>
        </Grid>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={handleAddClick}
          >
            Add Code
          </Button>
        </Grid>
      </Grid>

      <ResellerCodesList
        handleDeleteClick={handleDeleteClick}
        handleEditClick={handleEditClick}
      />

      {/* Add Reseller Code Dialog */}
      <ResellerCodeForm open={isAddDialogOpen} setOpen={setAddDialogOpen} />

      {/* Edit Reseller Code Dialog */}
      <ResellerCodeForm open={isEditDialogOpen} setOpen={setEditDialogOpen} />

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={isDeleteDialogOpen}
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this reseller code?
          </DialogContentText>
          {deleteError && (
            <Grid item xs={12}>
              <Alert severity="error">
                Error deleting reseller code: {formatQueryError(deleteError)}
              </Alert>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
          {selectedResellerCode && (
            <Button
              disabled={deleteIsLoading}
              onClick={() => deleteResellerCode(selectedResellerCode._id)}
            >
              Delete
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ResellerCodesPage;
